import { findLevel, findTopic, levelName, type HomeworkSource } from "@edu/shared";
import type { PreviewTasks } from "./AssignPreview.tsx";
import type { PlanSourceState } from "./use-plan-source.ts";
import type { TopicPicks } from "../../exercises/topics/use-topic-picks.ts";

/**
 * Что показать в предпросмотре над кнопкой (5.3 docs/homework-phase2-design.md).
 *
 * Отдельной функцией от формы, потому что это перевод заказа в слова, а не
 * состояние. Считается из ТОГО ЖЕ заказа, который уедет на сервер, а не из
 * состояния формы рядом с ним: предпросмотр, собранный по соседним полям,
 * однажды покажет не то, что отправится.
 */
export function previewTasks(
  order: HomeworkSource | null, plan: PlanSourceState, topics: TopicPicks,
): PreviewTasks | null {
  if (order === null) return null;
  if (order.kind === "plan") {
    return { kind: "plan", count: plan.picked.length, planTitle: plan.plan?.title ?? "" };
  }
  /*
    Обе генераторные ветки (`oge` и `eng`) показываются ОДНИМ обещанием: строки
    справочника у них одной формы, а разница между предметами уже сказана
    выбранным источником и названиями тем. Развилка по предмету здесь родила бы
    два одинаковых текста, расходящихся при первой же правке.
  */
  return {
    kind: "topics",
    count: topics.total,
    topics: topics.rows.flatMap((row) => {
      const topic = findTopic(topics.topics ?? [], row.skill);
      const level = topic === null ? null : findLevel(topic, row.difficulty);
      return topic === null || level === null
        ? []
        : [{ name: topic.name, level: levelName(level.difficulty), count: row.count }];
    }),
  };
}
